<template>
  <div class="w-12/12 p-0 pb-12">
    <Summary
      v-if="getFilteredSection('destination_summary')"
      :content="getFilteredSection('destination_summary')"
      :living-areas="getFilteredSection('living_areas')"
      :destination="destination"
    />
    <LazyDestinationHotels
      v-if="destination.destination_id"
      :destination-id="destination.destination_id"
      :destination-name="destination.id"
      title="charterDestinationHoteltitle"
      :subtext="getHotelIngress"
    />
    <LazyDestinationWeather
      v-if="getFilteredSection('weather')"
      :content="getFilteredSection('weather', true)"
      title="charterDestinationWeatherTitle"
    />
    <LazyDestinationMapBoxViewer
      class="mb-12"
      :destination="destination"
    />
    <LazyDealFinder
      v-if="getFilteredSection('destination_dealfinder')"
      :content="getFilteredSection('destination_dealfinder')"
      :display-title="false"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  destination: {
    type: Object,
    default: () => ({}),
  },

  filledSections: {
    type: Array,
    default: () => [],
  },

  shouldScrollToTop: {
    type: Boolean,
    default: false,
  },
})

const getFilteredSection = (filterString, includeAll) => {
  const section = props.filledSections.find(section => section.type === filterString)

  if (section && !includeAll) {
    return section.data
  }

  return section || null
}

const getHotelIngress = computed(() => {
  return getFilteredSection('hotel_list')?.ingress || ''
})
</script>

<style lang="scss">
@import "@layers/web/assets/scss/modules/charter/_charter-destination";
</style>
